import InfoIcon from 'components/icons/Info';
import { FC } from 'react';
import styled from 'styled-components';

const InfoStyled = styled.div`
  background-color: #eff8ff;
  stroke: #2e90fa;
  color: #1570ef;
  border-radius: 0.5rem;
  padding: 0.3rem 0.5rem;
  display: flex;
  font-size: 0.9rem;
  align-items: center;
  svg {
    margin-right: 0.5rem;
    height: 1rem;
  }
`;

type Props = {
  style?: React.CSSProperties | undefined;
};
const Info: FC<Props> = ({ children, style, ...props }) => {
  return (
    <InfoStyled style={style} {...props}>
      <div>
        <InfoIcon />
      </div>
      <p>{children}</p>
    </InfoStyled>
  );
};

export default Info;
